import React from 'react';
import styled, { keyframes, css } from 'styled-components';

const items = [
  {
    actionTaker: 'Jarrad',
    action: 'is attending',
  },
  {
    actionTaker: 'Elena & Alex',
    action: 'are attending',
  },
  {
    actionTaker: 'Olivia',
    action: 'opened their invite',
  },
  {
    actionTaker: 'Aurora & Matheus',
    action: 'are not attending',
  },
  {
    actionTaker: 'Isabelle & Gabe',
    action: 'opened their invite',
  },
  {
    actionTaker: 'Grandma & Grandpa',
    action: 'are attending',
  },
  {
    actionTaker: 'Lydia & Ken',
    action: 'are attending',
  },
  {
    actionTaker: 'Ryan',
    action: 'opened their invite',
  },
  {
    actionTaker: 'Aurora & Matt',
    action: 'opened their invite',
  },
  {
    actionTaker: 'Julia',
    action: 'is attending',
  },
];

const ITEMS_TO_SKIP = 5;

const wrapperAnimation = keyframes`
  50% {
    transform: rotateX(10deg) rotateY(-10deg) rotateZ(0deg);
  }
`;

const itmAnim = keyframes`
  0% {
    margin-bottom:0;
  }
  15%{
    max-height: 100px;
    transform: scale(1.15);
    margin-bottom:15px;
  }
  30% {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
    opacity: 1;
  }
  40% {
    transform: scale(1);
  }
  50% {
    transform: scale(1);
    filter: blur(0);
  }
  100% {
    max-height: 100px;
    opacity: .75;
    margin-bottom:15px;
    filter: blur(1px);
  }
`;

const Wrapper = styled.div`
  animation: ${wrapperAnimation} 10s ease-in-out infinite;
  background: var(--canvas-background);
  border-radius: 12px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 380px;
  margin: 0 auto;
  max-width: 340px;
  overflow-y: clip;
  opacity: 0.8;
  padding: 10px;
  transform: rotateX(10deg) rotateY(-20deg) rotateZ(3deg);
  width: 100%;
`;

const Item = styled.div`
  --dly: 3s;
  --dur: 4s;
  overflow: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  width: 100%;

  max-height: 0;
  opacity: 0;
  transform-origin: center;

  ${items.map((item, index) => {
    if (index > ITEMS_TO_SKIP)
      return css`
        animation: ${itmAnim} 0s forwards;
      `;
    return css`
      &:nth-child(${index + 1}) {
        animation: ${itmAnim} var(--dur) ease-in-out
          calc(var(--dly) * ${items.length - (index + 1) - (ITEMS_TO_SKIP - 1)})
          forwards;
      }
    `;
  })}
`;

const Inner = styled.div`
  padding: 15px;
`;

export default function GuestList() {
  return (
    <Wrapper>
      {items.map((item, index) => (
        <Item key={index}>
          <Inner>
            <strong>{item.actionTaker}</strong> {item.action}
          </Inner>
        </Item>
      ))}
    </Wrapper>
  );
}
